import React, { useEffect, useState } from 'react';
const estilosPopover = require('./popover.module.scss').default
import * as R from 'ramda'

export type PopoverProps = {
    conteudo?: any
    exibirConteudoComoTitle?:boolean
} & React.PropsWithChildren<any>

export const Popover = (props: PopoverProps) => {
    const [exibir, setExibir] = useState(false)
    const [fixar, setFixar] = useState(false)

    const obterConteudo = () => <div className={estilosPopover.conteudo}>
        {props.conteudo}
    </div>

    const [conteudo,setConteudo] = useState(obterConteudo())

    useEffect(() => {
        setConteudo(obterConteudo())
    },[props.conteudo])

    return <div
        style={{
            position: "relative"
        }}
        onMouseEnter={() => setExibir(true)} 
        onMouseLeave={() => setExibir(false)}
        onClick={() => setFixar(R.not)}
        title={props.exibirConteudoComoTitle ? props.conteudo : null}>

        {(props.exibirConteudoComoTitle ? false : fixar ? true : exibir) && <>{conteudo}</>}

        {props.children}
    </div>
}